document.addEventListener('DOMContentLoaded', function() {
	// Only run on mobile (max-width: 999px)
	const mediaQuery = window.matchMedia('(max-width: 999px)');

	if (mediaQuery.matches) {
		const menuItems = document.querySelectorAll('.wp-block-navigation-item.has-child');

		menuItems.forEach(item => {
			const submenu = item.querySelector('.wp-block-navigation__submenu-container');
			const link = item.querySelector('.wp-block-navigation-item__content');

			// Create toggle button if it doesn't exist
			let toggleButton = item.querySelector('.wp-block-navigation-submenu__toggle');

			if (!toggleButton) {
				toggleButton = document.createElement('button');
				toggleButton.classList.add('wp-block-navigation-submenu__toggle');
				toggleButton.setAttribute('aria-expanded', 'false');
				toggleButton.setAttribute('aria-label', 'Toggle submenu');
				item.appendChild(toggleButton);
			}

			// Function to toggle submenu state
			const toggleSubmenu = function(e) {
				e.preventDefault();
				e.stopPropagation();

				const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';

				toggleButton.setAttribute('aria-expanded', !isExpanded);

				if (isExpanded) {
					submenu.classList.remove('is-open');
				} else {
					submenu.classList.add('is-open');
				}
			};

			// Add click event to toggle button
			toggleButton.addEventListener('click', toggleSubmenu);

			// Make the link toggle the submenu too - both open AND close
			link.addEventListener('click', function(e) {
				// Always toggle the submenu when clicking the parent item on mobile
				toggleSubmenu(e);
			});
		});
	}

	// Listen for resize events to re-apply or remove behavior when screen size changes
	mediaQuery.addEventListener('change', function(e) {
		// You would need to add code here to handle dynamic changes between mobile and desktop
		if (e.matches) {
			// Re-initialize mobile menu
			// Code to set up mobile behavior
		} else {
			// Remove mobile-specific handlers
			// Code to restore desktop behavior
		}
	});
});